module.exports = __webpack_public_path__ + "img/IAB_TCF.aa1ae38f.png";